import { Card } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Image, Text, useMedia, View } from "tamagui";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const img = require("../../assets/screen-plug.png");

export const Plug = () => {
  const { sm } = useMedia();
  const { t } = useTranslation("blocks");
  return (
    <Card
      gap={"$4"}
      alignItems={"center"}
      justifyContent={"center"}
      paddingVertical={"$5"}
      {...(sm
        ? { variant: "borderless", shadow: "none", paddingHorizontal: 0 }
        : {
            shadow: "md",
          })}
    >
      <Text
        fontFamily={"$subtitle"}
        fontWeight={"$6"}
        fontSize={"$6"}
        lineHeight={"$6"}
        textAlign={"center"}
        color={"$gray-primary"}
      >
        {t("only-web.plug.message")}
      </Text>

      <Image maxWidth={200} maxHeight={200} src={img} />
      <View gap={"$2"}>
        {!sm && (
          <Text
            fontFamily={"$subtitle"}
            fontWeight={"$6"}
            fontSize={"$7"}
            lineHeight={"$7"}
            textAlign={"center"}
            color={"$gray-primary"}
          >
            {t("only-web.plug.message")}
          </Text>
        )}

        {!sm && (
          <Text
            fontFamily={"$body"}
            fontWeight={"$5"}
            fontSize={"$5"}
            lineHeight={"$5"}
            textAlign={"center"}
            color={"$gray-800"}
          >
            {t("only-web.plug.recommendation")}
          </Text>
        )}
        {sm && (
          <Text
            fontFamily={"$body"}
            fontWeight={"$5"}
            fontSize={"$4"}
            lineHeight={"$4"}
            textAlign={"center"}
            color={"$gray-800"}
          >
            {t("only-web.plug.recommendation")}
          </Text>
        )}
      </View>
    </Card>
  );
};
